(() => {
  'use strict';
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];
  const catalog = JSON.parse($('#PhytoCatalog')?.textContent || '[]');
  const routes = JSON.parse($('#PhytoRoutes')?.textContent || '{}');
  const root = routes.root || '/';
  const currency = routes.currency || 'EUR';
  const money = cents => new Intl.NumberFormat(routes.locale || 'it-IT', { style: 'currency', currency }).format(cents / 100);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const size = variant => (variant?.title?.match(/(\d+)\s*ml/i) || [null, variant?.title || ''])[1];
  const getProduct = key => catalog.find(p => p.key === key);
  const messages = JSON.parse($('#PhytoUI')?.textContent || '{}');
  const setCount = n => $$('[data-cart-count]').forEach(el => { el.textContent = n; el.hidden = !n; });
  setCount(routes.cart_count || 0);
  let pending = false;
  let opener = null;
  const drawer = $('#cart-drawer');
  const quick = $('#quick-shop');
  const search = $('#search-dialog');
  const toast = message => {
    const el = $('.toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('show');
    clearTimeout(toast.timer);
    toast.timer = setTimeout(() => el.classList.remove('show'), 5000);
  };
  const closeMenus = () => {
    $$('[data-menu]').forEach(el => el.setAttribute('aria-expanded', 'false'));
    $$('.mega').forEach(el => el.classList.remove('open'));
    $('[data-shade]')?.classList.remove('open');
  };
  const mobileButton = $('[data-mobile-toggle]');
  const languageMenu = $('.language-menu');
  const closeLanguage = () => { if (languageMenu) languageMenu.open = false; };
  const setMobile = open => {
    mobileButton?.setAttribute('aria-expanded', String(open));
    mobileButton?.setAttribute('aria-label', open ? messages.close_menu : messages.open_menu);
    const nav = $('.mobile-nav');
    if (nav) { nav.hidden = !open; nav.classList.toggle('open', open); }
    document.body.style.overflow = open ? 'hidden' : '';
    if ($('main')) $('main').inert = open;
    if ($('.site-footer')) $('.site-footer').inert = open;
  };
  $$('[data-menu]').forEach(button => button.addEventListener('click', () => {
    const open = button.getAttribute('aria-expanded') === 'true';
    closeMenus();
    if (!open) {
      button.setAttribute('aria-expanded', 'true');
      $('#menu-' + button.dataset.menu)?.classList.add('open');
      $('[data-shade]')?.classList.add('open');
    }
  }));
  $('[data-shade]')?.addEventListener('click', closeMenus);
  mobileButton?.addEventListener('click', () => { closeMenus(); setMobile(mobileButton.getAttribute('aria-expanded') !== 'true'); });
  $$('.mobile-nav a').forEach(el => el.addEventListener('click', () => setMobile(false)));
  languageMenu?.addEventListener('toggle', () => { if (languageMenu.open) { closeMenus(); setMobile(false); } });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (languageMenu?.open) { closeLanguage(); $('summary', languageMenu)?.focus(); }
    closeMenus();
    setMobile(false);
  });
  document.addEventListener('click', event => {
    if (!event.target.closest('.site-header')) closeMenus();
    if (!event.target.closest('.language-menu')) closeLanguage();
  });
  const openDialog = (dialog, from) => {
    closeMenus();
    closeLanguage();
    setMobile(false);
    opener = from || document.activeElement;
    if (dialog && !dialog.open) dialog.showModal();
  };
  [search, quick, drawer, $('#zoom-dialog')].filter(Boolean).forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => opener?.focus?.());
  });
  $$('[data-search-open]').forEach(button => button.addEventListener('click', () => { openDialog(search, button); $('input', search)?.focus(); }));
  $('[data-search-close]')?.addEventListener('click', () => search.close());
  $$('[data-cart-open]').forEach(button => button.addEventListener('click', () => openDialog(drawer, button)));
  $('[data-cart-close]')?.addEventListener('click', () => drawer.close());
  $('[data-quick-close]')?.addEventListener('click', () => quick.close());

  function displayVariant(form) {
    const select = $('[data-variant-select]', form);
    if (!select) return;
    const option = select.selectedOptions[0];
    const available = option.dataset.available === 'true';
    const info = form.closest('.pdp-info') || form.parentElement;
    $$('[data-native-variant]', form).forEach(button => button.setAttribute('aria-pressed', String(button.dataset.nativeVariant === select.value)));
    const price = $('[data-variant-price]', info);
    if (price) price.textContent = money(Number(option.dataset.price));
    const label = $('[data-variant-format]', info);
    if (label) label.textContent = option.textContent.split('—')[0].trim() + ' · Airless';
    const add = $('[data-native-add]', form);
    if (add) { add.disabled = !available; add.textContent = available ? messages.add : messages.unavailable; }
  }
  $$('[data-product-form]').forEach(form => {
    const select = $('[data-variant-select]', form);
    const query = new URLSearchParams(location.search);
    const requestedSize = query.get('formato');
    if (requestedSize) {
      const option = [...select.options].find(option => new RegExp('(^|\\s)' + requestedSize + '\\s*ml', 'i').test(option.textContent));
      if (option) select.value = option.value;
    }
    displayVariant(form);
    const changed = () => {
      displayVariant(form);
      const url = new URL(location.href);
      url.searchParams.set('variant', select.value);
      url.searchParams.delete('formato');
      history.replaceState(null, '', url);
    };
    select.addEventListener('change', changed);
    $$('[data-native-variant]', form).forEach(button => button.addEventListener('click', () => { select.value = button.dataset.nativeVariant; changed(); }));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity() || pending) return;
      const button = $('[data-native-add]', form);
      const error = $('.cart-error', form);
      error.textContent = '';
      const quantity = Math.min(20, Math.max(1, Number(form.elements.quantity.value || 1)));
      try {
        await changeCart('add', { items: [{ id: Number(select.value), quantity }] }, button);
        openDialog(drawer, button);
      } catch (e) { error.textContent = e.message; }
    });
  });
  $$('[data-qty-step]').forEach(button => button.addEventListener('click', () => {
    const input = $('input', button.closest('.qty'));
    input.value = Math.max(1, Math.min(20, Number(input.value || 1) + Number(button.dataset.qtyStep)));
  }));
  let quickSelection = null;
  $$('[data-quick-shop]').forEach(button => button.addEventListener('click', () => {
    const product = getProduct(button.dataset.quickShop);
    if (!product || !quick) return;
    quickSelection = { product, variant: null };
    $('#quick-shop-title').textContent = product.name;
    $('[data-quick-focus]', quick).textContent = product.focus;
    const image = $('[data-quick-image]', quick);
    image.src = product.image;
    image.alt = product.name;
    $('[data-quick-details]', quick).href = product.url;
    const add = $('[data-quick-add]', quick);
    add.disabled = true;
    add.textContent = messages.add;
    $('.quick-shop-note', quick).textContent = messages.choose;
    $('[data-quick-options]', quick).innerHTML = product.variants.map(variant => `<button type="button" data-quick-variant="${variant.id}" aria-pressed="false" ${variant.available ? '' : 'disabled'}><span>${size(variant)} ml</span><strong>${money(variant.price)}</strong>${variant.available ? '' : '<small>' + messages.unavailable + '</small>'}</button>`).join('');
    $$('[data-quick-variant]', quick).forEach(option => option.addEventListener('click', () => {
      const variant = product.variants.find(v => String(v.id) === option.dataset.quickVariant);
      quickSelection.variant = variant;
      $$('[data-quick-variant]', quick).forEach(el => { el.setAttribute('aria-pressed', String(el === option)); el.classList.toggle('active', el === option); });
      add.disabled = !variant.available;
      add.textContent = messages.add + ' · ' + money(variant.price);
      $('.quick-shop-note', quick).textContent = size(variant) + ' ml · ' + messages.airless + ' · Made in Italy';
      $('[data-quick-details]', quick).href = product.url + '?variant=' + variant.id;
    }));
    openDialog(quick, button);
  }));
  $('[data-quick-add]')?.addEventListener('click', async event => {
    if (!quickSelection?.variant || pending) return;
    try {
      await changeCart('add', { items: [{ id: quickSelection.variant.id, quantity: 1 }] }, event.currentTarget);
      quick.close();
      openDialog(drawer);
    } catch (error) { $('.quick-shop-note', quick).textContent = error.message; }
  });

  async function changeCart(action, payload, button) {
    if (pending) return;
    pending = true;
    const label = button?.textContent;
    if (button) { button.disabled = true; button.textContent = messages.pending; }
    $$('[data-cart-error]').forEach(el => { el.textContent = ''; });
    const drawerSection = $('#cart-drawer-content')?.dataset.cartRenderSection;
    const pageSection = $('[data-native-cart-page]')?.closest('.shopify-section')?.id?.replace('shopify-section-', '');
    const sections = [drawerSection, pageSection].filter(Boolean);
    const note = $('#cart-note')?.value;
    try {
      const endpoint = (action === 'add' ? routes.add : routes.change) || root + 'cart/' + action;
      const response = await fetch(endpoint + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...payload, sections, sections_url: location.pathname }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || messages.error);
      const parser = new DOMParser();
      if (result.sections?.[drawerSection]) {
        const html = parser.parseFromString(result.sections[drawerSection], 'text/html');
        const replacement = $('#cart-drawer-content', html);
        if (replacement) $('#cart-drawer-content').replaceWith(replacement);
      }
      if (pageSection && result.sections?.[pageSection]) {
        const html = parser.parseFromString(result.sections[pageSection], 'text/html');
        const replacement = $('[data-native-cart-page]', html);
        if (replacement) $('[data-native-cart-page]').replaceWith(replacement);
        if (note !== undefined && $('#cart-note')) $('#cart-note').value = note;
      }
      const cartResponse = action === 'change' ? result : await (await fetch((routes.cart || root + 'cart') + '.js', { headers: { Accept: 'application/json' } })).json();
      setCount(cartResponse.item_count);
      toast(action === 'add' ? messages.added : messages.updated);
      document.dispatchEvent(new CustomEvent('ph:cart:updated', {detail:cartResponse}));
      return cartResponse;
    } catch (error) {
      $$('[data-cart-error]').forEach(el => { el.textContent = error.message || messages.error; });
      throw error;
    } finally {
      pending = false;
      if (button?.isConnected) { button.disabled = false; button.textContent = label; }
    }
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cart-key], [data-cart-remove]');
    if (!button) return;
    event.preventDefault();
    if (pending) return;
    const id = button.dataset.cartKey || button.dataset.cartRemove;
    const quantity = button.hasAttribute('data-cart-remove') ? 0 : Math.min(20, Math.max(0, Number(button.dataset.quantity) + Number(button.dataset.step)));
    try { await changeCart('change', { id, quantity }, button); } catch (error) { toast(error.message); }
  });
  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-cart-input]');
    if (!input || pending) return;
    try { await changeCart('change', { id: input.dataset.cartInput, quantity: Math.min(20, Math.max(0, Number(input.value))) }); } catch (error) { toast(error.message); }
  });
  $$('[data-product-category]').forEach(button => button.addEventListener('click', () => {
    const category = button.dataset.productCategory;
    $$('[data-product-category]').forEach(el => { el.classList.toggle('active', el === button); el.setAttribute('aria-pressed', String(el === button)); });
    const categories = { sensibile: 'derma', tessuti: 'regenerative', esposizione: 'bursore', comfort: 'anti' };
    $$('[data-product-filter]').forEach(el => { el.hidden = category !== 'all' && el.dataset.productFilter !== categories[category]; });
  }));
  $('[data-faq-search]')?.addEventListener('input', event => {
    const value = event.target.value.toLocaleLowerCase();
    $$('details.qa').forEach(el => { el.hidden = !el.textContent.toLocaleLowerCase().includes(value); });
  });
  const mainImage = $('[data-pack-main]');
  $$('[data-gallery]').forEach(button => button.addEventListener('click', () => {
    if (!mainImage) return;
    $$('[data-gallery]').forEach(el => { el.setAttribute('aria-pressed', String(el === button)); el.classList.toggle('active', el === button); });
    mainImage.src = button.dataset.gallerySrc;
    mainImage.alt = button.dataset.galleryAlt || mainImage.alt;
    mainImage.closest('.pdp-stage')?.classList.toggle('is-wide', button.dataset.galleryType === 'editorial');
    mainImage.closest('.pdp-stage')?.classList.toggle('is-bottle', button.dataset.galleryType === 'bottle');
    mainImage.className = button.dataset.galleryType === 'original' ? 'original-art' : 'photo-main';
    const zoomImage = $('#zoom-dialog img');
    if (zoomImage) zoomImage.src = mainImage.src;
  }));
  $('[data-image-zoom]')?.addEventListener('click', event => openDialog($('#zoom-dialog'), event.currentTarget));
  $('[data-zoom-close]')?.addEventListener('click', () => $('#zoom-dialog').close());
  $$('[data-need-choice]').forEach(button => button.addEventListener('click', () => {
    const product = getProduct(button.dataset.needChoice);
    if (!product) return;
    $$('[data-need-choice]').forEach(el => { el.setAttribute('aria-pressed', String(el === button)); el.classList.toggle('active', el === button); });
    const result = $('[data-need-result]');
    result.hidden = false;
    result.style.setProperty('--product-bg', product.bg);
    result.innerHTML = `<div class="guide-product studio-photo"><img src="${esc(product.hero)}" alt="${esc(product.name)}" width="1024" height="1280"></div><div><span class="eyebrow">${esc(messages.guide_eyebrow)}</span><h2>${esc(product.name)}</h2><p>${esc(product.intro)}</p><a class="btn green" href="${esc(product.url)}">${esc(messages.guide_link)}</a><p class="tiny">${esc(messages.guide_note)}</p></div>`;
    result.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
  }));
  $$('[data-address-country]').forEach(select => { if (select.dataset.default) select.value = select.dataset.default; });

  window.PhytoHealCart = Object.freeze({add: async (items, from) => { if (pending) throw new Error(messages.pending); const cart = await changeCart('add', {items}); openDialog(drawer, from); return cart; }});
})();
